function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgArrowDownLeft = function SvgArrowDownLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M7.81 17.25H15a.75.75 0 110 1.5H6a.75.75 0 01-.75-.75V9a.75.75 0 011.5 0v7.19L17.47 5.47a.75.75 0 011.06 1.06L7.81 17.25z"
  }));
};
SvgArrowDownLeft.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgArrowDownLeft.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgArrowDownLeft;